<div class="modal-header d-flex align-items-center justify-content-center position-relative">
  <div><span class="font-semibold text-primary">Clone Product</span></div>
  <app-svg-icon [name]="'cross_button_border'" class="cross-button-border"></app-svg-icon>
  <app-svg-icon [name]="'cross'" [ngClass]="currentHoverEffect" class="cross-button"
    (click)="closeModel()"></app-svg-icon>
</div>
<form ngNativeValidate>
  <div class="modal-body mx-2">
    <div class="pb-0">
      <app-search-input [isVisibleSearchIcon]="true" class="w-100 d-block" [inputSearchValue]="inputValue"
        (inputSearchValueEmit)="inputValue=$event;onSearchChange(inputValue)"
        (inputActionIconClick)="onSearchChange($event)">
      </app-search-input>

      <div class="row mx-0 gap-2 d-flex flex-column mt-2 h-100">
        <div class="col flex-fill p-0 h_22rem">
          <app-ag-grid [dataModel]="agGridDataModel" (gridReady)="onGridReady($event)" [columnSettings]="true"
            [rowHeight]="27">
          </app-ag-grid>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex align-items-center justify-content-center pt-3 pb-2 mx-2">
    <app-button (buttonOutputEvent)="closeModel()" [buttonLabel]="'Cancel'"
      [buttonClass]="'pink_button'" [buttonType]="'button'">
    </app-button>
    <app-button [buttonLabel]="'Done'" [buttonClass]="'blue_button'" [buttonType]="'button'"
      (buttonOutputEvent)="cloneProduct()">
    </app-button>
  </div>
</form>